export default __webpack_public_path__ + "static/media/p-rock.86e54734.jpg";